import { BANNER_TEXT_VERSION, COOKIE_LIST_VERSION } from '@/constants/cookie-registry'
import { CONSENT_TEXT_KIND } from '@/constants/consent-texts'
import { readConsentState } from './state'
import { consentVersion } from './texts'

export const CONSENT_LIFETIME_MONTHS = 6
export const CONSENT_MAX_LIFETIME_MONTHS = 12

function addMonths(date, months) {
  const result = new Date(date.getTime())
  result.setMonth(result.getMonth() + months)
  return result
}

export function computeOptimisticExpiry(from) {
  const base = from || new Date()
  const months = Math.min(CONSENT_LIFETIME_MONTHS, CONSENT_MAX_LIFETIME_MONTHS)
  return addMonths(base, months).toISOString()
}

// The version the backend published, or the one that shipped with the build while it has not
// published that kind - in which case it accepts any version, so the constant is safe. Both are
// read through here so that nothing sends one version and stamps the cookie with another.
export function currentCookieListVersion() {
  return consentVersion(CONSENT_TEXT_KIND.COOKIE_LIST, COOKIE_LIST_VERSION)
}

export function currentBannerVersion() {
  return consentVersion(CONSENT_TEXT_KIND.COOKIE_BANNER, BANNER_TEXT_VERSION)
}

// Now keyed to the published list rather than to a constant in this repo, which is what the
// third decision in the migration asks for: a new cookie_list revision re-asks everyone. The
// trap that comes with it - bumping COOKIE_LIST_VERSION by hand stops mattering the day the
// backend publishes that kind - is documented in cookie-registry.js next to the constant.
export function needsReConsent(state) {
  if (!state || !state.cookieListVersion) return false
  return state.cookieListVersion !== currentCookieListVersion()
}

export function shouldShowBanner(state) {
  const current = state === undefined ? readConsentState() : state

  if (!current) return true
  if (current.isExpired) return true
  return needsReConsent(current)
}
